<template>
  <NavBar />
  <div class="container-fluid page-body-wrapper">
    <MenuBar />
    <div class="main-panel">
      <div class="content-wrapper">
        <div class="page-header" v-if="obj_product != null">
          <h3 class="page-title">
            <span class="page-title-icon bg-gradient-primary text-white me-2">
              <i class="mdi mdi-account"></i>
            </span>
            {{ obj_product.prd_name }}
            <span
              v-if="
                obj_product.prd_product_line != null &&
                obj_product.prd_product_line != ''
              "
              >({{ obj_product.prd_product_line }})</span
            >
            <span
              :class="[
                obj_product.prd_status == 0
                  ? 'badge badge-gradient-danger'
                  : 'badge badge-gradient-success',
              ]"
              style="font-size: 0.875rem; border-radius: 1rem"
            >
              {{ obj_product.prd_status == 1 ? "Active" : "Deactive" }}
            </span>
          </h3>
          <!-- :class="[
              obj_product.prn_stats == 1
                ? 'btn btn-block btn-lg badge badge-gradient-danger mt-4'
                : 'btn btn-block btn-lg badge badge-gradient-success mt-4',
            ]" -->
          <a
            class="btn btn-block btn-lg btn-gradient-primary mt-4"
            @click="btnManageStatus()"
            v-if="
              auth_store.logged_in_user != undefined &&
              auth_store.logged_in_user.user != null &&
              auth_store.logged_in_user.user.usr_role != null &&
              auth_store.logged_in_user.user.usr_role.url_role_code != 'VWR' &&
              auth_store.logged_in_user.user.usr_role.url_role_code != 'RST' &&
              obj_product != null
            "
            >{{
              obj_product.prd_status == 1 ? "Deactive" : "Active"
            }}
            Product</a
          >
        </div>

        <div
          class="row"
          v-if="
            obj_product != null &&
            lstProductReleases != null &&
            launch_release != null
          "
        >
          <div class="container" style="margin-bottom: 0px">
            <ScrollPanel style="width: 100%; height: 100%">
              <div
                v-for="(item, index) in lstProductReleases"
                :key="index"
                :class="
                  index % 2 != 0
                    ? 'timeline-block timeline-block-right'
                    : 'timeline-block timeline-block-left'
                "
              >
                <div class="marker"></div>
                <div class="timeline-content">
                  <h4 class="card-title" style="font-weight: 700">
                    Version - {{ item.prn_version }}
                  </h4>
                  <p>
                    <i class="mdi mdi-calendar"></i> Released On
                    {{ formatDateTime(item.prn_release_date) }}
                  </p>
                  <p
                    class="text-info"
                    @click="
                      displayUserDetail($event, item.prn_usr_id)
                    "
                  >
                    <i class="mdi mdi-account"></i> Released By
                    {{ item.prn_created_by }}({{ item.prn_usr_role }})
                  </p>
                  <p>
                    <i class="mdi mdi-settings"></i> Firmware Version
                    {{ item.prn_firmware }}
                  </p>
                  <p
                    v-if="
                      auth_store.logged_in_user != undefined &&
                      auth_store.logged_in_user.user != null &&
                      auth_store.logged_in_user.user.usr_role != null &&
                      auth_store.logged_in_user.user.usr_role.url_role_code !=
                        'RST'
                    "
                  >
                    <a
                      class="text-primary"
                      :title="'Download ' + item.prn_file_name"
                      @click="downloadReleaseNote(item)"
                      ><i class="mdi mdi-cloud-download"></i> Download Release
                      Note</a
                    >
                  </p>
                </div>
              </div>
            </ScrollPanel>
          </div>
          <div
            data-v-42187d01=""
            style="text-align: center"
            v-if="launch_release != null"
            class="justify-content-center lanuch-div"
          >
            <div class="row launch" style="--bs-gutter-x: 25px">
              <div class="launch-marker">
                <p class="launch-text">Launch</p>
              </div>
            </div>
            <div class="row" style="margin-top: 1rem">
              <div class="timeline-content-launch" data-v-42187d01="" style="">
                <h4 class="card-title" style="font-weight: 700">
                  Version - {{ launch_release.prn_version }}
                </h4>
                <p>
                  <i class="mdi mdi-calendar"></i> Released On
                  {{ formatDateTime(launch_release.prn_release_date) }}
                </p>
                <p
                  class="user-info-label"
                  @click="displayUserDetail($event, launch_release.prn_usr_id)"
                  style="color: #2b3889"
                >
                  <i class="mdi mdi-account"></i> Released By
                  {{ launch_release.prn_created_by }}({{
                    launch_release.prn_usr_role
                  }})
                </p>
                <p>
                  <i class="mdi mdi-settings"></i> Firmware Version
                  {{ launch_release.prn_firmware }}
                </p>
                <p>
                  <a
                    class="text-primary"
                    :title="'Download ' + launch_release.prn_file_name"
                    @click="downloadReleaseNote(launch_release)"
                    v-if="
                      auth_store.logged_in_user != undefined &&
                      auth_store.logged_in_user.user != null &&
                      auth_store.logged_in_user.user.usr_role != null &&
                      auth_store.logged_in_user.user.usr_role.url_role_code !=
                        'RST'
                    "
                    ><i class="mdi mdi-cloud-download"></i> Download Release
                    Note</a
                  >
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          class="emptyGridMsgSec"
          v-if="
            obj_product == null ||
            lstProductReleases == null ||
            launch_release == null
          "
        >
          <i class="mdi mdi-note-outline"></i>
          <h3>No Record Found</h3>
          <p class="text-muted">
            We didn't find anything to show here, please try again
          </p>
        </div>
      </div>
    </div>
  </div>

  <ConfirmDialog group="headless">
    <template #container="{ message, acceptCallback, rejectCallback }">
      <div
        class="flex flex-column align-items-center p-5 surface-overlay border-round"
      >
        <div
          class="border-circle bg-gradient-primary inline-flex justify-content-center align-items-center text-white h-6rem w-6rem -mt-8"
        >
          <i
            class="mdi mdi-account-off mdi-24px"
            v-if="actionType == 'deactive'"
          ></i>
          <i
            class="mdi mdi-account-check mdi-24px"
            v-if="actionType == 'active'"
          ></i>
        </div>
        <span class="font-bold text-2xl block mb-2 mt-4">{{
          message.header
        }}</span>
        <p class="mb-0">{{ message.message }}</p>
        <div class="flex align-items-center gap-2 mt-4">
          <!-- <Button label="Save" @click="acceptCallback"></Button>
                    <Button label="Cancel" outlined @click="rejectCallback"></Button> -->
          <BButton
            class="btn btn-block btn-gradient-success btn-lg font-weight-medium auth-form-btn"
            @click="acceptCallback"
            >Submit
          </BButton>
          <BButton class="btn btn-light" @click="rejectCallback"
            >Cancel
          </BButton>
        </div>
      </div>
    </template>
  </ConfirmDialog>

  <OverlayPanel ref="op">
    <div class="flex flex-column gap-3">
      <div class="flex align-items-center gap-2">
        <img src="../../assets/images/user-icon.png" style="width: 3rem" />
        <div>
          <span class="font-medium"
            >{{ user.user.usr_user_name }}({{ user.user.url_role_desc }})</span
          >
          <p class="text-sm text-color-secondary" id="userEmail">
            {{ user.user.usr_email }} &nbsp;<span
              ><i
                class="mdi mdi-content-copy mdi-20px"
                @click="copyToClipBoard(user.user.usr_email)"
                v-if="!isTextCopied"
                v-tooltip="{
                  value: 'Click to Copy',
                  showDelay: 1000,
                  hideDelay: 300,
                }"
              ></i>
              <i
                class="mdi mdi-check-all mdi-20px"
                style="color: limegreen"
                v-if="isTextCopied"
                v-tooltip="{
                  value: 'Copied',
                  showDelay: 1000,
                  hideDelay: 300,
                }"
              ></i
            ></span>
          </p>
        </div>
        <!--  -->
      </div>
      <hr style="margin: -0.5rem 0" />
      <div class="flex align-items-center gap-2">
        <a
          :href="
            'mailto:' +
            user.user.usr_email +
            '?subject=your title&body=The message'
          "
        >
          <img src="../../assets/images/outlook-logo.png" style="width: 3rem" />
          <p class="text-sm">Outlook</p>
        </a>
        <a
          :href="
            'https://teams.microsoft.com/l/chat/0/0?users=' +
            user.user.usr_email
          "
          target="_blank"
        >
          <img src="../../assets/images/teams-logo.png" style="width: 3rem" />
          <p class="text-sm">Teams</p>
        </a>
      </div>
    </div>
  </OverlayPanel>
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted } from "vue";
import MenuBar from "@/components/shared/common/menu-bar.vue";
import NavBar from "@/components/shared/common/nav-bar.vue";
import { useAuthStore } from "@/store/auth_store";
import router from "@/router";
import axios from "axios";
import ScrollPanel from "primevue/scrollpanel";
import ConfirmDialog from "primevue/confirmdialog";
import { useConfirm } from "primevue/useconfirm";
import { toast } from "vue3-toastify";
import { format } from "date-fns";
import OverlayPanel from "primevue/overlaypanel";

const confirm = useConfirm();
const actionType = ref(null);
const auth_store = useAuthStore();

const obj_product = ref(null);
const lstProductReleases = ref([]);
const launch_release = ref(null);
const content_type = ref("");

const op = ref();
const isTextCopied = ref(false);
const showUserInfo = ref(false);
const user = ref({});

onMounted(() => {
  

  if (
    auth_store.selectedProduct == undefined &&
    auth_store.selectedProduct == null
  )
    router.push({ name: "released-product" });
  else obj_product.value = auth_store.selectedProduct;

  fetchReleases();
});

async function fetchReleases() {
  if (obj_product.value != null) {
    await axios
      .get("/fetch_product_releases?prd_id=" + obj_product.value.prd_id)
      .then((res) => {
        if (res.data != null) {
          
          lstProductReleases.value = res.data.lst_product_releases;
          if (lstProductReleases.value.length > 0) {
            launch_release.value =
              lstProductReleases.value[lstProductReleases.value.length - 1];
           
            lstProductReleases.value.splice(
              lstProductReleases.value.length - 1,
              1,
            );
          }

          
        }
      })
      .catch((err) => {
      
      });
  } else {
    router.push({ name: "released-product" });
  }
}

const btnManageStatus = () => {
 
  actionType.value = obj_product.value.prd_status == 1 ? "deactive" : "active";

  confirm.require({
    group: "headless",
    header: "Are you sure? ",
    message:
      obj_product.value.prd_status == 1
        ? "Please confirm to deactivate the product."
        : "Please confirm to activate the product",
    accept: () => {
      // obj_product.value.prn_stats = obj_product.value.prn_stats == 1 ? 0 : 1;
      
      if (obj_product.value != null) {
        axios
          .post("/manage_product_status?prd_id=" + obj_product.value.prd_id)
          .then((res) => {
            if (
              res.data != undefined &&
              res.data.retVal != undefined &&
              res.data.retVal != null &&
              res.data.retVal == 1
            ) {
              toast(res.data.message, {
                autoClose: 2000,
                theme: "colored",
                type: "success",
                position: "bottom-left",
                dangerouslyHTMLString: true,
              });
              obj_product.value.prd_status =
                obj_product.value.prd_status == 1 ? 0 : 1;
            }
            
          })
          .catch((err) => {
            toast(err.response.data.detail, {
              autoClose: 2000,
              theme: "colored",
              type: "error",
              position: "bottom-left",
              dangerouslyHTMLString: true,
            });
          });
      } else {
        router.push({ name: "released-product" });
      }
    },
    reject: () => {
      
      return;
    },
  });
};

const downloadReleaseNote = (objselectedItem) => {
  const obj_file = {
    file_path: objselectedItem.prn_file_location,
    file_name: objselectedItem.prn_file_name,
    prd_name: obj_product.value.prd_name,
    file_type: "versions",
  };

  axios
    .post("/download_file", obj_file, { responseType: "blob" })
    .then((res) => {
      if (res.data != undefined && res.data != null) {
        const file_type = objselectedItem.prn_file_name.split(".")[1];

        if (file_type == "pdf") content_type.value = "application/pdf";
        else if (file_type == "docx")
          content_type.value =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        else if (file_type == "doc") content_type.value = "application/msword";
        else if (file_type == "xlsx")
          content_type.value =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        else if (file_type == "xls")
          content_type.value = "application/vnd.ms-excel";
        else content_type.value = "application/text";

        const blob = new Blob([res.data], {
          type: content_type.value,
        }); //"application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = objselectedItem.prn_file_name;
        link.click();
      }
    })
    .catch((err) => {
      
      toast("File not Found.", {
        autoClose: 2000,
        theme: "colored",
        type: "error",
        position: "bottom-left",
        dangerouslyHTMLString: true,
      });
    });
};

function formatDateTime(value) {
  if (value != null) return format(value, "MMM dd, yyyy").toLocaleString();
  return "";
}

const displayUserDetail = (event, usr_id) => {
  op.value.toggle(event);
 
  // Fetch User Details
  axios
    .get("/fetch_user_by_usr_id?usr_id=" + usr_id)
    .then((res) => {
      showUserInfo.value = true;
      
      user.value = res.data;
      
    })
    .catch((err) => {
      
    });
};

const copyToClipBoard = (strData) => {
  isTextCopied.value = false;
  // Copy the text inside the text field
  navigator.clipboard.writeText(strData);

  isTextCopied.value = true;
  resetStatus();
};

function resetStatus() {
  setTimeout(() => {
    isTextCopied.value = false;
  }, 5000);
}
</script>

<style scoped>
.container {
  width: 80%;
  padding: 50px 0;
  margin: 50px auto;
  position: relative;
  overflow: hidden;
}

.container:before {
  content: "";
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -1px;
  width: 2px;
  height: 100%;
  background: #2b89e0;
  z-index: 1;
}

.timeline-block {
  width: -webkit-calc(50% + 8px);
  width: -moz-calc(50% + 8px);
  width: calc(50% + 8px);
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -moz-box-pack: justify;
  justify-content: space-between;
  clear: both;
}

.timeline-block-right {
  float: right;
}

.timeline-block-left {
  float: left;
  direction: rtl;
}

.marker {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #f5f7fa;
  background: linear-gradient(to right, #89aed9, #163a64) !important;
  margin-top: 10px;
  z-index: 9999;
  box-shadow: 0px 3px 8.3px 0.7px rgba(163, 93, 255, 0.35);
}

.timeline-content {
  width: 95%;
  padding: 0 15px;
  color: #666;
  background-color: #f9f9f9;
  padding: 0.5rem;
  box-shadow: 0px 3px 8.3px 0.7px rgb(74 77 87 / 35%);
}

.timeline-content-launch {
  /* width: 95%; */
  padding: 0 15px;
  color: #666;
  background-color: #f9f9f9;
  padding: 0.5rem;
  width: 39%;
  margin: 1% 0% 0% 31.5%;
  box-shadow: 0px 3px 8.3px 0.7px rgb(74 77 87 / 35%);
}

.timeline-content h3,
.timeline-content-launch h3 {
  margin-top: 5px;
  margin-bottom: 5px;
  font-size: 25px;
  font-weight: 500;
}

.timeline-content span,
.timeline-content-launch span {
  font-size: 15px;
  color: #a4a4a4;
}

.timeline-content p,
.timeline-content-launch p {
  font-size: 12px;
  line-height: 0.3em;
  word-spacing: 1px;
  color: #888;
}

.launch-marker {
  width: 75px;
  height: 75px;
  border-radius: 50%;
  border: 2px solid #f5f7fa;
  background: linear-gradient(to right, #89aed9, #163a64) !important;
  /* margin-top: 10px; */
  z-index: 9999;
  box-shadow: 0px 3px 8.3px 0.7px rgba(163, 93, 255, 0.35);
  /* margin: -4.5% 0% 0% 47.1%; */
}

.launch {
  justify-content: center !important;
  /*margin: 0.25rem !important;*/
}
.launch-text {
  /* display: none; */
  margin: 23px 0px;
  color: rgb(255, 255, 255);
}

@media screen and (max-width: 768px) {
  .container:before {
    left: 8px;
    width: 2px;
  }

  .timeline-block {
    width: 100%;
    margin-bottom: 30px;
  }

  .timeline-block-right {
    float: none;
  }

  .timeline-block-left {
    float: none;
    direction: ltr;
  }
  .timeline-content-launch {
    margin: 0% 0% 0% 0%;
    float: left;
    width: 95%;
    direction: ltr;
  }
  .launch-marker {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #f5f7fa;
    background: linear-gradient(to right, #89aed9, #163a64) !important;
    margin: 0% 0% 0% 2%;
    z-index: 9999;
    box-shadow: 0px 3px 8.3px 0.7px rgba(163, 93, 255, 0.35);
  }
  .launch-text {
    /* display: none; */
    margin: 14px -13px;
    color: rgb(255, 255, 255);
    font-size: 11px;
  }
  .launch {
    justify-content: flex-start !important;
    /*margin: 0.25rem !important;*/
  }
}

@media screen and (min-width: 680px) and (max-width: 768px) {
  .lanuch-div {
    margin-left: 2rem !important;
  }
}
@media screen and (min-width: 566px) and (max-width: 667px) {
  .lanuch-div {
    margin-left: 1.5rem !important;
  }
}
@media screen and (min-width: 465px) and (max-width: 565px) {
  .lanuch-div {
    margin-left: 1rem !important;
  }
}

@media screen and (min-width: 369px) and (max-width: 465px) {
  .lanuch-div {
    margin-left: -0.5rem !important;
  }
  .launch-marker {
    margin: 0% 0% 0% 5%;
  }
}
</style>
